import Page from '../../classes/Page'
import Hero from '../../modules/Hero'
import { app } from '../../utils/store'
import each from 'lodash/each'

export default class TaxonomyKind extends Page{
    constructor(){
        super({
            id : 'taxonomy_kind',
            element: '[data-app-page]',
            elements: { 
                hero: document.querySelectorAll('[data-carousel="hero"]'),
                anchors: 'section.listing ul.anchors',
            },
            scroller: app.viewport
        })
    }

    create() {
        super.create()
        if (this.elements.hero) { this.createHero() }
        if (this.elements.anchors) { this.createObserver() }

        app.scroll = app.viewport
    }

    createHero() {
        each(this.elements.hero, (entry) => { return new Hero({ element: entry }) })
    }

    createObserver() {
        if(app.scroll == app.viewport){
            document.documentElement.style.setProperty('overflow','hidden')
        }

        this.anchors = {
            container: this.elements.anchors,
            links: this.elements.anchors.querySelectorAll(`a[href^="#"]`),
            sections: new Array()
        }

        if(this.anchors.container){
            app.anchors = this.anchors
            app.root.style.setProperty('--anchors-height', `${this.anchors.clientHeight}px`)
        }

        each(this.anchors.links, (link) => {
            this.anchors.sections.push(document.querySelector(`${link.hash}`))
        })

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                this.scroll.currentX = entry.boundingClientRect.x
                this.scroll.currentRatio = entry.intersectionRatio

                if (entry.isIntersecting) { // "Scrolling UP" this.scroll.currentY < this.scroll.previousY &&
                    // if (this.scroll.currentRatio > this.scroll.previousRatio) { // "Scrolling UP Enter"
                    each(this.anchors.links, (link) => link.classList.remove('active'))
                    this.elements.anchors.querySelector(`a[href="#${entry.target.id}"]`).classList.add('active')
                    // } else { // "Scrolling UP Leave"
                    //this.elements.anchors.querySelector(`a[href="#${entry.target.id}"]`).classList.remove('active')
                    // }
                } else {
                    // Do nothing
                }

                this.scroll.previousX = this.scroll.currentX
                this.scroll.previousRatio = this.scroll.currentRatio
            })
        }, {
            rootMargin: `-40%`,
        })

        each(this.anchors.sections, (section) => {
            // console.log(section)
            this.observer.observe(section)
        })
    }
    
    addEventListeners() {
        window.addEventListener('resize', () => {
            if(this.elements.anchors){
                app.root.style.setProperty('--anchors-height', `${this.elements.anchors.clientHeight}px`)
            }
        })
    }

    destroy(){ 
        super.destroy()
    }
}